require('lang');

// CSS
require("css/global.css");
require("def.css");
require("css/layout.css");
require("ui-lightness/jquery-ui-1.8.24.custom.css");
require("article.css");
require("css/flexboxgrid.min.css");
require("highlight.css");
require("editor_rewrite.css");
require("css/font-awesome.css");
require("css/flags.css");
require("css/tooltipDOI.css");


// JS
require('script-loader!js/jquery_1_10_2.js');
require('script-loader!js/jquery_ui_1_10_2.js');
require('script-loader!js/jquery.simplemodal_1_4_4.js');
require('script-loader!js/jquery_form.js');
require('script-loader!js/def.js');
require('script-loader!js/jquery.history.js');
require('script-loader!js/article.js');
require('script-loader!js/global.js');
require('script-loader!js/article_formulas.js');

// global.ckeditor_head
// require('script-loader!editors/ckeditor_4.4/plugins/lite/lite-interface.js');
// require('script-loader!editors/ckeditor_4.4/ckeditor.js');
// require('script-loader!editors/ckeditor_4.4/adapters/jquery.js');

//global.jquery_plot_head
require('script-loader!js/jquery.jqplot.min.js');
require('script-loader!js/jqplot.barRenderer.min.js');
require('script-loader!js/jqplot.categoryAxisRenderer.min.js');
require('script-loader!js/jqplot.highlighter.min.js');
require('script-loader!js/jqplot.cursor.min.js');
require('script-loader!js/jqplot.pointLabels.min.js');
require('script-loader!js/jqplot.donutRenderer.min.js');


require('script-loader!js/ua-parser.min.js');
